import i18n from 'i18next';
import _get from 'lodash/get';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';
import { setLocale } from 'yup';
import en from './en';
import vi from './vi';

export const resources = {
  en: {
    translation: en
  },
  vi: {
    translation: vi
  }
};

export default i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});

export { i18n };

setLocale(_get(resources.en, 'translation.validation'));
moment.updateLocale('en', _get(resources.en, 'translation.moment'));
